import { useEffect, useState } from 'react';

import { CAMPAIGN_POST_SORT } from '@/entities/campaign';

import type { PostFilterOption, PostViewMode } from '@/features/campaign/ui/campaign-detail/hooks';

export function useCampaignDetailPostTabState() {
  const [postFilter, setPostFilter] = useState<PostFilterOption>('all');
  const [postSort, setPostSort] = useState<CAMPAIGN_POST_SORT>(CAMPAIGN_POST_SORT.POSTED_AT_DESC);
  const [postViewMode, setPostViewMode] = useState<PostViewMode>('card');
  const [postPage, setPostPage] = useState(1);

  useEffect(() => {
    setPostPage(1);
  }, [postFilter, postSort, postViewMode]);

  return {
    isRecentPosts: postFilter === 'recent',
    postFilter,
    postPage,
    postSort,
    postViewMode,
    setPostFilter,
    setPostPage,
    setPostSort,
    setPostViewMode,
  };
}
